var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stickers mt-4 mb-12"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"text-h4 mb-8"},[_vm._v(" Samolepky na inzulinové pero ")]),_c('v-row',_vm._l((_vm.stickers),function(sticker){return _c('v-col',{key:sticker.title,attrs:{"md":"6"}},[_c('StickerCard',{attrs:{"item":sticker}})],1)}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }